(function (angular) {
	'use strict';

	angular.module('transactionActivityTableModule', [
		'coreModule'
	]);
})(window.angular);